import auth from '../../middleware/auth';

const props = (route) => {
	return {
		id: parseInt(route.params.id),
		page: route.query.page || 1
	};
};

export default {
	path: 'connections/:id(\\d+)',
	name: 'connection-view',
	props: props,
	component: () => import('../../../views/connections/ConnectionView'),
	meta: {
		middleware: [
			auth
		]
	}
};
